<div
  class="ion-text-left question-text question ProseMirror"
  xmlns="http://www.w3.org/1999/html"
>
  @if (model.type == TextType.NONE) {
    <div [innerHTML]="model._textResolved"></div>
  } @else if (model.type == TextType.HIGHLIGHT) {
    <div [class.textHighlight]="TextType.HIGHLIGHT">
      <ion-grid>
        <ion-row>
          <ion-col size="12" [innerHTML]="model._textResolved">
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  } @else if (model.type == TextType.TABLE) {
    <div
      class="textTable"
      [ngClass]="{ textTable: true, wideTable: isMobile || numberOfColumns > 4 }"
      [innerHTML]="model._textResolved"
    ></div>
  } @else {
    <div
      [class.textImportant]="model.type == TextType.IMPORTANT"
      [class.textTip]="model.type == TextType.TIP"
      [class.textInfo]="model.type == TextType.INFO"
      [class.textSuccess]="model.type == TextType.SUCCESS"
    >
      <ion-grid>
        <ion-row>
          <ion-col class="icon-col" size="12" size-sm="1">
            <ion-icon [name]="getIcon()" size="large"></ion-icon>
          </ion-col>
          <ion-col size="12" size-sm="11" [innerHTML]="model._textResolved">
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  }
</div>
